/** @file routeHash: the location hash of an editor Route (the inverse of parseHash). */
import type { Route } from '../../state/editorTypes';

/** `{ screen: 'pose', puppetId: 'pup_x' }` → `#/u/pup_x/pose`; a project's puppets → `#/p/<id>`; projects, settings. */
export function routeHash(route: Route): string {
  switch (route.screen) {
    case 'projects': return '#/projects';
    case 'settings': return '#/settings';
    case 'puppets': return `#/p/${encodeURIComponent(route.projectId)}`;
    case 'pose':
    case 'art':
    case 'agent': return `#/u/${encodeURIComponent(route.puppetId)}/${route.screen}`;
    case 'tile': {
      const t = route.tile;
      return `#/u/${encodeURIComponent(route.puppetId)}/tile/${encodeURIComponent(t.drawable)}/${String(t.entry)}/${String(t.tile)}`;
    }
  }
}
